// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import ScheduleController from "./schedule_controller"
application.register("schedule", ScheduleController)

import AutoRefreshController from "./auto_refresh_controller"
application.register("auto-refresh", AutoRefreshController)

import ConfirmOverrideController from "./confirm_override_controller"
application.register("confirm-override", ConfirmOverrideController)
